<template>
     <div>
         <div class="panel panel-default">
             <div class="panel-heading">
                 <div style="display: flex; justify-content: space-between; align-items: center;">
                   <span>
                       <a class="hide-panel" @click="showClientList">Clients</a>
                            &nbsp;/&nbsp;
                        <template v-if="view.active === 'profile'">
                            {{ client.name }}
                        </template>
                        <template v-else>
                            <a class="hide-panel" @click="hideDetails">{{ client.name }}</a>
                            {{`&nbsp;/&nbsp; ${view.name}`}}
                        </template>
                   </span>
               </div>
             </div>
         </div>
     </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    data() {
        return {}
    },

    computed: {
        ...mapGetters('client',{
            'client': 'activeClient',
            'view': 'view',
        }),
    },

    methods: {
        showClientList() {
            history.pushState(null, null, '#/clients');
            this.$store.dispatch('client/showClientListView');
        },

        hideDetails() {
            history.pushState(null, null, `#/clients/${this.client.slug}`);
            this.$store.dispatch('client/showClientProfile');
        },
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/clients/ClientBreadcrumbs.vue